// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"UploadImage--next-sr-only--169sZK4","uploadImg":"UploadImage--uploadImg--2EGC9D7","uploadComponent":"UploadImage--uploadComponent--3DQxQ75"};